<template>
  <div class="global-loading" v-if="isLoading">
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isLoading () {
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/base/var.scss';

.global-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 72px;
  z-index: 999;
  transform:translate(-8px, -36px);
  .spinner {
    width: 70px;
    text-align: center;
  }

  .spinner > div {
    width: 12px;
    height: 12px;
    background-color: $btnTextColor;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
            animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
            animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
              transform: scale(0);
    } 40% {
      -webkit-transform: scale(1.0);
              transform: scale(1.0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/loading.vue